module.exports = __webpack_public_path__ + "static/media/sub-form-logo.818a4d37.png";